<template>
     
    <v-sheet color="white" class="pa-1">
        <!-- Input para tipo de Documento -->
        <v-select v-model="editedItem.documento" :items="tipo" label="Tipo documento"
            @change="buscarVentaPorTipo"></v-select>


    <!-- Inicio de modal para fecha de factura -->
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedDateFormatted"
              label="Fecha Documento"
              persistent-hint
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="editedItem.fecha"
            locale="es-ES"
            :min="fechaMin"
            :max="fechaMax"
            no-title
            @input="menu2 = false"
            @change="setDocumento"
          ></v-date-picker>
        </v-menu>

      <!-- FIN  de modal para fecha de factura -->

       
        <v-row>
            <v-col>
                <v-text-field v-model="editedItem.serie" label="Serie" @change="buscarVentaPorTipo"
            :disabled="editedItem.documento == 'Factura Electrónica'"></v-text-field>
            </v-col>
            <v-col>
                <v-text-field v-model="editedItem.numero" label="Número"
            :disabled="editedItem.documento == 'Factura Electrónica'"></v-text-field>
            </v-col>
        </v-row>
        

        
        
    </v-sheet>
</template>
<script>
import dayjs from "dayjs";

export default {

    data: () => ({
        fechaActual:dayjs().format(),
        modal: false,
        menu2: false,
        tipo: ["Factura Electrónica", "Proforma", "Recibo","Envios","Venta al Credito"],
        editedItem: {
            fecha:dayjs().format("YYYY-MM-DD H:mm:ss"),
            documento: "Factura Electrónica",
            numero: 1,
            serie: "A",
        },
        defaultItem: {
            fecha:dayjs().format("YYYY-MM-DD H:mm:ss"),
            documento: "Factura Electrónica",
            numero: 1,
            serie: "A",
        },
    }),
    created() {
        this.buscarVentaPorTipo()
        this.$emit('setdocumento',this.editedItem)
    },
    computed:{
        computedDateFormatted () {
        return dayjs(this.editedItem.fecha).format("DD/MM/YYYY")
        },
        fechaMin(){
            return  this.calculofechaMin()
        },
        fechaMax(){
            return this.calculofechaMax()
        },
    },
    methods: {
        setFecha(){
            const horaActual = dayjs().format("H:mm:ss")
            this.editedItem.fecha=`${this.editedItem.fecha} ${horaActual}`
        },
        // Calculamos la fecha minima documento
        calculofechaMin(){
            if(this.editedItem.documento=="Factura Electrónica"){
                return  dayjs(this.fechaActual).subtract(5,'days').format("YYYY-MM-DD H:mm:ss") //Validacion Factura Electronica
            }else{
                return  dayjs(this.fechaActual).subtract(2,'years').format("YYYY-MM-DD H:mm:ss") //Validacion Otro tipo documento
            }
        },

        // Calculamos la fecha minima documento
        calculofechaMax(){
            if(this.editedItem.documento=="Factura Electrónica"){
                return dayjs(this.fechaActual).endOf('month').format("YYYY-MM-DD H:mm:ss") //Validacion Factura Electronica
            }else{
                return  dayjs(this.fechaActual).add(2,'years').format("YYYY-MM-DD H:mm:ss")//Validacion Otro tipo documento
            }
        },

        buscarVentaPorTipo() {
            const ventas = this.$store.getters.getAllVentas
            //Si el Tipo es = Factura le Asignamos serie FEL

            if(this.editedItem.documento=="Venta al Credito") this.editedItem.pagado = "No"

            if (ventas) {
                //Filtramos las ventas por tipo
                const filtro = ventas.filter(elemento => {

                    if (elemento.documento == this.editedItem.documento && elemento.estado == 'Activo' && elemento.serie == this.editedItem.serie) {
                        return elemento
                    }
                })
                if (filtro.length == 0) this.editedItem.numero = 1
                else {
                    //Buscamos el ultimo numero del tipo de documento
                    const numeroSiguiente = filtro.sort((item1, item2) => {
                        return parseInt(item2.numero) - parseInt(item1.numero)
                    })
                    this.editedItem.numero = parseInt(numeroSiguiente[0].numero) + 1
                }

            }
            //this.setDocumento()
            this.$emit('setdocumento',this.editedItem)
        },
        setDocumento(){
          
            this.setFecha() //Establecemos la Fecha
            this.$emit('setdocumento',this.editedItem)
        }
    }
}
</script>